/**
 * AreaGroupEmptyState — contextual empty state for the area groups table.
 * @param {{ type: 'no-data' | 'no-results', onAddGroup?: () => void, onClearFilters?: () => void }} props
 */
const AreaGroupEmptyState = ({ type, onAddGroup, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="ap-empty">
        <div className="ap-empty__icon-wrap">
          <i className="fe fe-layers ap-empty__icon" aria-hidden="true" style={{ fontSize: '1.5rem' }} />
        </div>
        <h3 className="ap-empty__title">No area groups yet</h3>
        <p className="ap-empty__text">
          Get started by creating your first area group. Groups help organize areas for monitoring, reporting, and management.
        </p>
        {onAddGroup ? (
          <button
            type="button"
            onClick={onAddGroup}
            className="ap-btn ap-btn--primary"
          >
            <i className="fe fe-plus" aria-hidden="true" />
            New Group
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="ap-empty">
      <div className="ap-empty__icon-wrap">
        <i className="fe fe-search ap-empty__icon" aria-hidden="true" style={{ fontSize: '1.5rem' }} />
      </div>
      <h3 className="ap-empty__title">No results found</h3>
      <p className="ap-empty__text">
        No area groups match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="ap-btn ap-btn--outline"
        >
          <i className="fe fe-x" aria-hidden="true" />
          Clear All Filters
        </button>
      ) : null}
    </div>
  );
};

export default AreaGroupEmptyState;
